var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import Select from 'react-select';
import { ThemeConsumer } from 'styled-components';
import { getColor } from '../helpers/ColorHelpers';
import { appendPx } from '../theme/DefaultTheme';
export { components } from "react-select"; // for usage outside ui
export function customStyles(theme) {
    return {
        clearIndicator: function (provided, state) { return (__assign({}, provided)); },
        container: function (provided, state) { return (__assign({}, provided)); },
        control: function (provided, state) {
            return __assign(__assign({}, provided), { 
                //minHeight: 40,
                fontSize: "1em", 
                //height: 40,
                //overflowY: "auto",
                borderRadius: appendPx(theme.select.borderRadius), cursor: "pointer", boxShadow: "none", borderColor: state.isFocused ? getColor({ theme: theme }, theme.colors.lightGrey) : getColor({ theme: theme }, theme.colors.middleLightGrey), "img": { marginTop: -10 }, "&:hover": {
                    borderColor: getColor({ theme: theme }, theme.colors.lightGrey)
                } });
        },
        dropdownIndicator: function (provided, state) { return (__assign({}, provided)); },
        group: function (provided, state) { return (__assign({}, provided)); },
        groupHeading: function (provided, state) { return (__assign({}, provided)); },
        indicatorsContainer: function (provided, state) { return (__assign(__assign({}, provided), { 
            //height: 38,
            padding: 0 })); },
        indicatorSeparator: function (provided, state) { return (__assign(__assign({}, provided), { marginTop: 8, marginBottom: 8 })); },
        input: function (provided, state) { return (__assign({}, provided)); },
        loadingIndicator: function (provided, state) { return (__assign({}, provided)); },
        loadingMessage: function (provided, state) { return (__assign({}, provided)); },
        menu: function (provided, state) { return (__assign(__assign({}, provided), { borderRadius: appendPx(theme.select.borderRadius) })); },
        menuList: function (provided, state) { return (__assign(__assign({}, provided), { borderRadius: appendPx(theme.select.borderRadius), hoverColor: getColor({ theme: theme }, theme.select.hoverColor) })); },
        menuPortal: function (provided, state) { return (__assign({}, provided)); },
        multiValue: function (provided, state) { return (__assign(__assign({}, provided), { lineHeight: "28px", paddingLeft: "6px", backgroundColor: getColor({ theme: theme }, theme.colors.veryLightGrey), borderRadius: "0px" })); },
        multiValueLabel: function (provided, state) { return (__assign({}, provided)); },
        multiValueRemove: function (provided, state) { return (__assign(__assign({}, provided), { borderRadius: "0px", "&:hover": {
                backgroundColor: getColor({ theme: theme }, theme.colors.veryLightGrey),
                color: getColor({ theme: theme }, theme.colors.accentRed),
                borderRadius: "0px"
            } })); },
        noOptionsMessage: function (provided, state) { return (__assign({}, provided)); },
        option: function (provided, state) { return (__assign(__assign({}, provided), { 
            //color: state.isSelected ? getColor({ theme: theme }, theme.select.optionFontHoverColor) : getColor({ theme: theme }, theme.select.optionFontColor),
            color: getColor({ theme: theme }, theme.select.optionFontColor), fontSize: "1em", padding: "0 5px !important", lineHeight: "32px", 
            //backgroundColor: state.isSelected ? getColor({ theme: theme }, theme.select.optionBackgroundHoverColor) : getColor({ theme: theme }, theme.select.optionBackgroundColor),
            backgroundColor: getColor({ theme: theme }, theme.select.optionBackgroundColor), "&:hover": {
                backgroundColor: getColor({ theme: theme }, theme.select.optionBackgroundHoverColor),
                color: getColor({ theme: theme }, theme.select.optionFontHoverColor),
            } })); },
        placeholder: function (provided, state) { return (__assign({}, provided)); },
        singleValue: function (provided, state) { return (__assign(__assign({}, provided), { overflow: "unset" })); },
        valueContainer: function (provided, state) { return (__assign({}, provided)); },
    };
}
;
var ImgSelect = /** @class */ (function (_super) {
    __extends(ImgSelect, _super);
    function ImgSelect(props) {
        var _this = _super.call(this, props) || this;
        _this.create = function (theme) {
            return customStyles(theme);
        };
        _this.state = {};
        return _this;
    }
    ImgSelect.prototype.render = function () {
        var _this = this;
        return (React.createElement(ThemeConsumer, null, function (theme) {
            return React.createElement(Select, __assign({ styles: _this.create(theme) }, _this.props));
        }));
    };
    return ImgSelect;
}(React.PureComponent));
export default ImgSelect;
//# sourceMappingURL=ImgSelect.js.map